import { HIDE_SNACKBAR, SHOW_SNACKBAR } from './types';

const initialState = {
    snackbars: [],
};

const isSnackbarExist = (snackbars, id) => snackbars.find(snackbar => snackbar.id === id);

export default (state = initialState, { type, payload }) => {
    switch (type) {
        case SHOW_SNACKBAR:
            return {
                ...state,
                snackbars: !isSnackbarExist(state.snackbars, payload.id)
                    ? [].concat(state.snackbars, {
                        id: payload.id,
                        snackbarProps: Object.assign(payload.snackbarProps, { open: true }),
                    }) : state.snackbars,
            };
        case HIDE_SNACKBAR:
            return {
                ...state,
                snackbars: state.snackbars.filter(snackbar => snackbar.id !== payload),
            };
        default:
            return state;
    }
};
